import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardGuard } from 'auth-app-lib';
import { UserPlanGuard } from 'psc-ng-common';

import { SubscriptionGuard } from './shared/services/subscription.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuardGuard],
    canActivateChild: [UserPlanGuard, SubscriptionGuard],
    loadChildren: () =>
      import('./modules/home/home.module').then((m) => m.HomeModule),
    data: { redirect: '' },
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./auth-lib.module').then((m) => m.AuthLibModule),
  },
  {
    path: 'legal',
    loadChildren: () =>
      import('./modules/legal/legal.module').then((m) => m.LegalModule),
  },

  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
